import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Tabs, Typography } from 'antd';
import React, { useEffect } from 'react';
import { BankDetails } from './BankDetails';
import { CompanyDetails } from './CompanyDetails';
import { CurrencyDetails } from './CurrencyDetails';
import styles from './index.module.scss';
import './index.scss';
import { IntegrationDetails } from './IntegrationDetails';

type Props = {
	isOpen: boolean;
	onCancel: () => void;
	edit: any;
	isPayrollRun: any;
	defaultTab?: any;
};

const EditCompanyModal = (props: Props) => {
	const { onCancel, isOpen, edit, isPayrollRun, defaultTab } = props;

	const [activeKey, setActiveKey] = React.useState(
		defaultTab || 'companyDetails'
	);

	useEffect(() => {
		if (isOpen && defaultTab) {
			setActiveKey(defaultTab);
		}
	}, [isOpen, defaultTab]);
	const changeTab = (key: any) => {
		setActiveKey(key);
	};

	let tabItems = [
		{
			key: 'companyDetails',
			label: 'Company Details',
			children: (
				<CompanyDetails
					changeTab={changeTab}
					onCancel={onCancel}
					editData={edit}
					isPayrollRun={isPayrollRun}
				/>
			),
			destroyInactiveTabPane: false,
		},
		{
			key: 'bankDetails',
			label: 'Bank Details',
			children: <BankDetails changeTab={changeTab} onCancel={onCancel} />,
			destroyInactiveTabPane: false,
		},
		{
			key: 'currency',
			label: 'Currency Setup',
			children: (
				<CurrencyDetails onCancel={onCancel} changeTab={changeTab} />
			),
			destroyInactiveTabPane: false,
		},
		{
			key: 'integrationDetails',
			label: 'Integration Details',
			children: (
				<IntegrationDetails onCancel={onCancel} editData={edit} />
			),
			destroyInactiveTabPane: false,
		},
	];

	return (
		<Modal
			open={isOpen}
			onCancel={onCancel}
			footer={null}
			maskClosable={false}
			width={1500}
			closable={false}
			centered
			rootClassName="company-setup-modal"
		>
			<div className={styles['modal-header']}>
				<Typography.Title level={4}>
					<span>Add Company Details</span>
				</Typography.Title>
				<Button icon={<CloseOutlined />} onClick={onCancel} />
			</div>
			<div className={styles['company-component']}>
				<div className="company-component-tabs">
					<Tabs
						defaultActiveKey={activeKey}
						activeKey={activeKey}
						items={tabItems}
						onChange={(key) => changeTab(key)}
						style={{
							fontSize: '18px',
							marginBottom: '20px',
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default EditCompanyModal;
